import { ToastPosition } from '@chakra-ui/react';

export const TOAST_DEFAULT_OPTIONS = {
  duration: 5000,
  isClosable: false,
  titleAlignment: 'top',
  variant: 'subtle',
  position: 'bottom' as ToastPosition,
};

export const TOAST_UPDATE_PERSONAL_INFO = {
  duration: 5000,
  isClosable: true,
  variant: 'subtle',
  position: 'bottom' as ToastPosition,
};
